export const  formatDate = (dateInput: string | null): string => {
if( !dateInput) return ""
  const date = new Date(dateInput);
  const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}-${day} ${year}`;
}

export const getStatusChipColor = (status: string) => {
  switch (status) {
    case "approved":
      return "success";
    case "pending":
      return "warning";
    case "rejected":
      return "error";
    case "document_submitted":
      return "info";
    case "pending_additional_documents":
      return "secondary";
    case "scheduled_interview":
      return "primary";
    case "draft":
      return "default";
    case "active":
      return "info"
    default:
      return "default";
  }
};